export default __webpack_public_path__ + "static/media/hero-lg.626a2944.png";